import { render, staticRenderFns } from "./PensionMode.vue?vue&type=template&id=c2cf20c0&scoped=true&"
import script from "./PensionMode.vue?vue&type=script&lang=ts&"
export * from "./PensionMode.vue?vue&type=script&lang=ts&"
import style0 from "./PensionMode.vue?vue&type=style&index=0&id=c2cf20c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cf20c0",
  null
  
)

export default component.exports